import { BaseButtonOutline } from '..';

import './SummaryHelpers.scss';

export const SummaryInput = ({ name, condition = true, children, ...rest }) => {
  const isFn = typeof children == 'function';

  return condition ? (
    <li className="base-summary__item row">
      <span className="col-6 base-summary__item-title">{name}</span>
      <span className="col-6 base-summary__item-value" data-testid={rest['data-testid']}>
        {isFn ? children() : children || '-'}
      </span>
    </li>
  ) : null;
};

export const SummaryCombinedValue = ({ condition, subtitle, subvalue, children }) => (
  <span className="base-summary__combined-value">
    <span>{children}</span>
    {condition && (
      <span className="base-summary__combined-value-wrapper">
        <span className="combined-value__subtitle">{subtitle}</span>
        <span className="combined-value__subvalue">{subvalue}</span>
      </span>
    )}
  </span>
);

export const SummaryWrapper = (props) => {
  return (
    <div className="base-summary__section-wrapper">
      <div className="base-summary__section-heading">
        <h1 className="heading heading--bold heading--color-primary heading--subsection">{props.heading}</h1>
        {/* TODO: move change logic to HOC / wrapper */}
        {typeof props.step === 'number' && (
          <BaseButtonOutline onClick={() => props.goToStep(props.step)} data-testid="summary-edit-button">
            {props.buttonText}
          </BaseButtonOutline>
        )}
      </div>
      {props.children}
    </div>
  );
};
